import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { TerminalService } from '@app/services/terminal.service';

@Component({
  selector: 'app-terminal-login',
  templateUrl: './terminal-login.component.html',
  styleUrls: ['./terminal-login.component.css']
})
export class TerminalLoginComponent implements OnInit {
  constructor(
    private auth: AuthService,
    private terminal: TerminalService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  async ngOnInit() {
    await this.terminalAuth();
  }

  terminalAuth() {
    return new Promise(async (resolve, reject) => {
      // 打刻端末認証
      const serialId = localStorage.getItem('serialId');
      console.log(serialId);
      if (serialId !== null) {
        const res = await this.auth.terminalLogin(serialId);
        if (res) {
          console.log('success terminalLogin');
          const isPWA = await this.terminal.isPWATerminal();
          if (isPWA) {
            console.log('PWA terminal start');
            await this.router.navigate(
              ['/terminal/punch-stamp']
            );
          } else {
            console.log('not PWA terminal');
            await this.auth.logout();
          }
        } else {
          await this.router.navigate(['/home/login'], {relativeTo: this.route });
          console.log('fail terminalLogin');
        }
      }
    });
  }


}
